import MojitoPresentation from 'mojito/presentation';
import MojitoModules from 'mojito/modules';

import {merge} from '#core/utils/config-utils.js';
import {flopShadow, resolveBackground} from '#core/utils/color-utils.js';
import {buildIntentsFromConfig} from '#core/utils/intent-factory.js';

import {AbstractVisualFeature} from '../../visual-feature.js';
import {generateDotNotification} from '../../tiles/dot-notification/index.js';
import {Interface} from '../interface.js';

import PALETTE_SCHEMA from './mobile-nav-bar.palette-schema.yaml';
import SCHEMA from './mobile-nav-bar.schema.yaml';

const {NOTIFICATIONS} = MojitoModules.QuickLinks.types;

class MobileNavBarFeature extends AbstractVisualFeature {
    get name() {
        return 'Mobile NavBar';
    }

    get configSchema() {
        return SCHEMA;
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getVisualConfig(PALETTE) {
        return {
            QuickLinks: {
                isDotNotificationVisible: true,
                dotNotification: merge(generateDotNotification(PALETTE.DOT_NOTIFICATION), {
                    style: {
                        container: {
                            position: 'absolute',
                            top: '-4px',
                            right: '-4px',
                        },
                    },
                }),
                container: {
                    style: {
                        height: 48,
                        boxShadow: flopShadow(PALETTE.CONTAINER_SHADOW),
                        ...resolveBackground(PALETTE.CONTAINER_BG),
                    },
                },
                linkButton: {
                    style: {
                        base: {
                            gap: 4,
                        },
                    },
                },
                // better to leave it like it is now
                linkIcon: {
                    style: {
                        minHeight: 16,
                        minWidth: 16,
                        fill: PALETTE.ICON_COLOR,
                    },
                },
                linkLabel: {
                    style: {
                        whiteSpace: 'nowrap',
                        fontSize: 10, // 10 for all clients, it is not correlated with FONT.SIZE_SMALL
                        textTransform: 'capitalize',
                        ...PALETTE.LABEL_TEXT,
                    },
                },
                links: this.getQuickLinksConfig(),
            },
        };
    }

    getQuickLinksConfig() {
        let links = buildIntentsFromConfig(this.config.mobileNavigationBarItems);

        return links.map(link => {
            if (link.intent.type === MojitoPresentation.Base.Intent.Types.SHOW_SLIDING_OPEN_BETS) {
                link.notification = {
                    onActions: [NOTIFICATIONS.HAS_OPEN_BETS],
                };
            }

            return link;
        });
    }
}

new MobileNavBarFeature(Interface);
